import { useEffect, useState } from 'react';
import { useVisitorPresence } from '@/hooks/useVisitorPresence';

// Inner component only mounts (and its hook only runs) after the browser is idle,
// so the Supabase Realtime channel doesn't compete with initial render/hydration.
function VisitorPresenceInner() {
  useVisitorPresence();
  return null;
}

export function VisitorPresenceTracker() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const start = () => { if (!cancelled) setReady(true); };

    if ('requestIdleCallback' in window) {
      const id = (window as any).requestIdleCallback(start, { timeout: 5000 });
      return () => { cancelled = true; (window as any).cancelIdleCallback?.(id); };
    }
    const t = setTimeout(start, 3000);
    return () => { cancelled = true; clearTimeout(t); };
  }, []);

  if (!ready) return null;
  return <VisitorPresenceInner />;
}
